// extracted by mini-css-extract-plugin
export default {"slot":"film-carousel_slot__1UWUI","hidden":"film-carousel_hidden__1xLpu","card":"film-carousel_card__2I-q7"};